/* eslint-disable react/forbid-prop-types */
import DownloadScientificProfile from 'features/ProjectProposal/components/DownloadScientificProfile';
import Warning from 'features/ProjectProposal/components/Warning';
import { Tooltip } from 'primereact/tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { getAcadamicLevelShortHand, getContactOrganizationName } from 'utils/func';

function ResearchRow({
  item,
  index,
  config,
  handleDownloadFile,
  onBindingIntoContactFieldClick,
  researcherRef,
  disabled,
  organizations,
}) {
  const { scientificProfileToolTipTarget, updateItem, removeItem, projectRoleId } = config;
  const { t } = useTranslation();

  return (
    <>
      <td className="text-center" style={{ minWidth: 45, width: 45 }}>
        {index + 1}
      </td>
      <td style={{ minWidth: 200, width: '27%' }}>
        {`${getAcadamicLevelShortHand(item?.academicRank, item?.academicDegree, t, true)}${
          item?.fullname
        }`}
        {item?.contact?.user?.scientificProfileUrl ? (
          <DownloadScientificProfile
            contactId={item?.contact?.id || item?.contactId}
            contactName={item?.fullname}
            academicRank={item?.academicRank}
            academicDegree={item?.academicDegree}
            handleDownloadFile={handleDownloadFile}
          />
        ) : (
          <Warning
            message={t('projectProposal.general.researchHumanResources.noScientificProfileUrl')}
            tooltipTarget={`${scientificProfileToolTipTarget}-${index}`}
          />
        )}
        {item?.isAuthorized && (
          <>
            <i
              className="tick-icon pi pi-pencil border-primary-900 ml-2"
              data-pr-tooltip={t('projectProposal.general.researchHumanResources.fields.authority')}
              data-pr-position="right"
            />
            <Tooltip target=".tick-icon" />
          </>
        )}
      </td>
      <td className="text-center" style={{ minWidth: 100, width: '5%' }}>
        {t(`userProfile.gender.${item?.gender}`)}
      </td>
      <td style={{ width: '26.5%' }}>
        {getContactOrganizationName(organizations, item?.contact, t)}
      </td>
      <td style={{ width: '27%' }}>{item?.assignedTask}</td>
      {!disabled && (
        <td
          className="flex flex-column float text-center p-0 border-none border-bottom-1"
          width="*"
        >
          <i
            onMouseDown={() => {
              onBindingIntoContactFieldClick(item.email, updateItem, index, item);
            }}
            className="refresh-icon pi pi-replay text-green-500 cursor-pointer py-2"
            data-pr-tooltip={t('formLayout.action.refresh')}
            data-pr-position="left"
          />
          <Tooltip target=".refresh-icon" />

          <i
            onMouseDown={() => {
              researcherRef.current.open({
                projectRoleId,
                update: updateItem,
                index,
                value: item,
                type: 'UPDATE',
              });
            }}
            className="edit-icon pi pi-pencil bg-red text-primary cursor-pointer py-1"
            data-pr-tooltip={t('formLayout.action.edit')}
            data-pr-position="left"
          />
          <Tooltip target=".edit-icon" />

          <i
            onMouseDown={() => removeItem(index)}
            className="remove-icon pi pi-times text-red-700 cursor-pointer py-2"
            data-pr-tooltip={t('formLayout.action.remove')}
            data-pr-position="left"
          />
          <Tooltip target=".remove-icon" />
        </td>
      )}
    </>
  );
}

ResearchRow.propTypes = {
  item: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  config: PropTypes.object.isRequired,
  handleDownloadFile: PropTypes.func.isRequired,
  onBindingIntoContactFieldClick: PropTypes.func.isRequired,
  researcherRef: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  organizations: PropTypes.array.isRequired,
};

ResearchRow.defaultProps = {
  disabled: false,
};

export default React.memo(ResearchRow);
